import { PromptType } from "@src/types.generated";

export const GRADED_PROMPT_TYPES = [
  PromptType.GradedFreeResponse,
  PromptType.MultipleChoice,
  PromptType.ImageChoice,
  PromptType.TrueFalse,
  PromptType.Matching,
  PromptType.Ordering,
];
